import Phaser from 'phaser';
import { sfx } from '@/systems/sfx';

export function animateModalGlide(
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  opts?: { offset?: number; duration?: number; spillLyd?: boolean },
): void {
  const offset = opts?.offset ?? 40;
  const duration = opts?.duration ?? 200;
  const spillLyd = opts?.spillLyd !== false;

  if (spillLyd) sfx.play('pageturn');

  const sluttY = container.y;
  container.y = sluttY + offset;
  container.alpha = 0;

  scene.tweens.add({
    targets: container,
    y: sluttY,
    alpha: 1,
    duration,
    ease: 'Cubic.easeOut',
  });
}

export function animateFabBounce(
  scene: Phaser.Scene,
  target: Phaser.GameObjects.GameObject,
): void {
  scene.tweens.add({
    targets: target,
    scale: { from: 1.0, to: 0.92 },
    duration: 75,
    yoyo: true,
    ease: 'Sine.easeInOut',
  });
}

export function animateBadgePulse(
  scene: Phaser.Scene,
  target: Phaser.GameObjects.GameObject,
): void {
  scene.tweens.add({
    targets: target,
    scale: { from: 1.0, to: 1.2 },
    duration: 150,
    yoyo: true,
    ease: 'Sine.easeOut',
  });
}
